export default __webpack_public_path__ + "static/media/b.671157d4.png";